import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "app-header__wrapper" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "app-header__logo",
  src: _imports_0,
  alt: "БАХТ"
}, null, -1)
const _hoisted_5 = {
  key: 2,
  class: "app-header__search-bar search-bar",
  for: "search-bar-input"
}
const _hoisted_6 = ["placeholder", "value"]
const _hoisted_7 = {
  key: 3,
  class: "app-header__title"
}

import { computed } from 'vue';
import IconWeight from '@/icons/icon-weight.vue';
import IconArrowLeft from '@/icons/icon-arrow-left.vue';
import { useRoute, useRouter } from 'vue-router';
import IconCross from '@/icons/icon-cross.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  props: {
  withSearch: {
    type: Boolean,
    default: true,
  },
  withBackBtn: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
  },
  search: {
    type: String,
  },
},
  setup(__props) {

const router = useRouter();
const route = useRoute();

const isMyOrdersPage = computed(() => route.path.startsWith('/orders'));



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (__props.withBackBtn)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "app-header__back-btn",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => _unref(router).back(), ["prevent"]))
            }, [
              _createVNode(IconArrowLeft)
            ]))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: { name: 'catalog' }
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })),
        (__props.withSearch)
          ? (_openBlock(), _createElementBlock("label", _hoisted_5, [
              _createElementVNode("input", {
                type: "text",
                id: "search-bar-input",
                placeholder: _ctx.$t('search'),
                value: __props.search,
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:search', $event.target.value)))
              }, null, 40, _hoisted_6),
              (__props.search)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "search-bar__clear",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('update:search', '')), ["prevent"]))
                  }, [
                    _createVNode(IconCross)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(__props.title), 1)),
        _createVNode(_component_router_link, {
          to: { name: 'orders' },
          class: _normalizeClass([
            'my-orders-btn',
            isMyOrdersPage.value ? 'my-orders-btn--active' : '',
          ])
        }, {
          default: _withCtx(() => [
            _createVNode(IconWeight)
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ])
  ]))
}
}

})